import * as React from "react"
import { clx } from "../utils/clx"
import { VariantProps, cva } from "cva"

const statusBadgeVariants = cva({
  base: "txt-compact-small-plus inline-flex items-center justify-center min-h-5 px-2 rounded-full",
  variants: {
    color: {
      orange: "bg-orange-lighter text-orange-dark [&_div]:bg-orange-dark",
      yellow: "bg-yellow-100 text-yellow-800 [&_div]:bg-yellow-800",
      green: "bg-green-lighter text-green-dark [&_div]:bg-green-dark",
      blue: "bg-blue-lighter text-blue-dark [&_div]:bg-blue-dark",
      teal: "bg-teal-lighter text-teal-dark [&_div]:bg-teal-dark",
      purple: "bg-purple-lighter text-purple-base [&_div]:bg-purple-base",
      red: "bg-red-lighter text-red-base [&_div]:bg-red-base",
      grey: "bg-grey-10 text-ui-fg-subtle [&_div]:bg-grey-40",
      white: "bg-grey-0 text-ui-fg-base [&_div]:bg-orange-base border border-ui-border-strong",
    },
  },
  defaultVariants: {
    color: "grey",
  },
})

export interface StatusBadgeProps
  extends Omit<React.ComponentPropsWithoutRef<"span">, "color">,
    VariantProps<typeof statusBadgeVariants> {
  indicator?: boolean
}

/**
 * This component is based on the span element and supports all of its props
 */
const StatusBadge = React.forwardRef<HTMLSpanElement, StatusBadgeProps>(
  (
    {
      children,
      className,
      /**
       * The status's color.
       */
      color = "grey",
      indicator = true,
      ...props
    }: StatusBadgeProps,
    ref
  ) => {
    return (
      <span
        ref={ref}
        className={clx(statusBadgeVariants({ color }), className)}
        {...props}
      >
        {indicator && (
          <div role="presentation" className="flex items-center justify-center w-1 h-1 rounded-full mr-1" />
        )}
        {children}
      </span>
    )
  }
)
StatusBadge.displayName = "StatusBadge"

export { StatusBadge }
